<template lang="pug">
  .cancel-sub-reasons-modal.narrow-modal-body.xs-f-small.max-at-tweak
    SectionTitle(text="Sorry to see you go" data-mr-ass="sorry-modal").text-center
    p We're constantly trying to improve our products and services. Please let us know your reason for canceling:

    form(@submit="submitCancelForm")
      fieldset
        .row.reason-wrap(v-for="reason in cancelReasons" :key="reason.id")
          .choice.xs-12
            MrRadio(v-model="selectedReason" :value="reason" name="reason" data-mr-ass="reason-radio-button")
              span {{ reason.reason }}

            TransitionExpand
              p(v-if="reason.mention_nnn && reason.id == selectedReason.id") Our Knockout collection of permanent colors is specifically designed to cover even the most resistant grays — without sacrificing depth, tone, shine, or dimensionality.
                SectionLink(url="/knockout-gray-hair" link-text="See more" :vue-route="false")

            TransitionExpand
              textarea(v-if="reason.has_comment && reason.id == selectedReason.id" v-model="comment" placeholder="Please tell us more (optional)" maxlength="255").xs-11

      p(v-if="annualSavings").text-center I understand I will no longer receive my convenient subscription savings of ${{ annualSavings }} per year.
      
      SubmitButtons(
        submit-text="Confirm Cancelation"
        :submit-method="submitCancelForm"
        :submit-disabled="!selectedReason.id || savingSub"
        cancel-text="Cancel"
        :cancel-method="cancel"
      )
  
</template>

<script>
  import { mapActions, mapState, mapMutations } from "vuex";
  import SectionTitle from "../../../SectionTitle";
  import SubmitButtons from "../../../SubmitButtons";
  import MrRadio from "../../../mrRadio";
  import TransitionExpand from "../../../TransitionExpand";
  import SectionLink from "../../SectionLink";

  export default {
    name: "EditAutoDeliveryCancelReasonsModal",
    data() {
      return {
        selectedReason: {},
        comment: null
      }
    },

    components: {
      SectionLink,
      TransitionExpand,
      MrRadio,
      SubmitButtons,
      SectionTitle
    },

    computed: {
      ...mapState('subscriptions', [
        'subInEdit',
        'savingSub',
        'cancelReasons'
      ]),

      annualSavings() {
        if (!this.subInEdit.product_info) {
          return;
        }

        return Math.ceil((this.subInEdit.product_info.price - this.subInEdit.product_info.sub_price) * (52 / this.subInEdit.frequency) * this.subInEdit.qty);
      }
    },

    mounted() {
      let { code, product_type } = this.subInEdit;
      let payload = {
        product_type,
        code
      }
      this.getCancelReasons(payload);
    },

    methods: {
      ...mapActions('subscriptions', [
        'cancelSubscription',
        'getCancelReasons'
      ]),

      ...mapActions('modal', ['hideModal']),

      ...mapMutations('subscriptions', [
        'setCancelReasons'
      ]),

      submitCancelForm() {
        var payload = {
          sub_id: this.subInEdit.id,
          reason: this.selectedReason
        };

        if (this.comment && this.comment.length) {
          payload.comment = this.comment;
        }

        this.cancelSubscription(payload).then(this.cleanup);
      },

      cancel() {
        this.cleanup();
      },

      cleanup() {
        this.setCancelReasons();
        this.hideModal();
      }
    }
  }
</script>

<style scoped lang="stylus">
  p
    padding 1.2em 0

  .reason-wrap
    padding 0.5em 0

  .submit-buttons
    padding-top 2em

  textarea
    margin-top 0.5em
    margin-left 1.7em

</style>